module.exports = __webpack_public_path__ + "static/oil_complex-640aca8013bfd0ee51c9b691de0bed67.jpg";